module.exports = __webpack_public_path__ + "img/fullLoad.feb87331.png";